import { combineReducers } from 'redux';

const rootReducer = combineReducers({});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.R.js